/**
 * Created by katarinababic on 10.6.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useToast } from '../Hooks/useToast';
import { Theme } from '../Theme/Theme';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 1999;
  pointer-events: none;
`;

const ToastWrapper = styled.div`
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const fadeOut = keyframes`
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-10px); }
`;

const ToastMessage = styled.div<{ type: string; closing?: boolean }>`
  min-width: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: ${(props) =>
    props.type === 'success'
      ? Theme.Colors.success
      : props.type === 'error'
      ? Theme.Colors.error
      : Theme.Colors.primary};
  color: ${Theme.Colors.white};
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0px 16px 32px rgba(0, 0, 0, 0.5);
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  text-align: center;
  pointer-events: auto;
  // Play fade-in or fade-out animation
  animation: ${(props) => (props.closing ? fadeOut : fadeIn)} 0.3s ease-out forwards;
`;

export type ToastProps = {};

export const Toast: React.FC<ToastProps> = observer(() => {
  const toast = useToast();

  if (toast.toasts.length === 0) {
    return null;
  }

  return (
    <React.Fragment>
      <Overlay />
      <ToastWrapper>
        {toast.toasts.map((t) => (
          <ToastMessage key={t.id} type={t.type} closing={t.closing}>
            {t.type === 'success' && <i className="bi bi-check-circle-fill" />}
            {t.message}
          </ToastMessage>
        ))}
      </ToastWrapper>
    </React.Fragment>
  );
});
